import React from 'react';
import PropTypes from 'prop-types';
import Svgs from '../../resources/svgs';
import InfoTooltip from '../bitsnbobs/info-tooltip';
import './widget.scss';

const Widget = (props) =>
  <div className="widget-container">
    <div className="widget-header"
    data-event="track-component"
    data-component-name={`Widget Switcher ${props.title}`}
    data-component-link={`Switch active view to ${props.title}`}
    data-component-link-placement="1"
    data-component-link-type="header"
    onClick={props.onWidget}>
      <div className="widget-title">
        <div className="widget-title-text"
        data-event="track-component"
        data-component-name={`Widget Switcher ${props.title}`}
        data-component-link={`Switch active view to ${props.title}`}
        data-component-link-placement="1"
        data-component-link-type="title"
        onClick={props.onWidget}>{props.title}</div>
        {/* {Svgs.description}</div> */}
        <div className="info-icon">
          {props.hideToolTip ? null
            : <InfoTooltip title={props.info}></InfoTooltip>
          }
        </div>
        {props.inline
          ? <div className="inline-content"> {props.children}</div>
         : null}
        <div className="eye-icon"
        data-event="track-component"
        data-component-name={`Widget Switcher ${props.title}`}
        data-component-link={`Switch active view to ${props.title}`}
        data-component-link-placement="1"
        data-component-link-type="title"
        onClick={props.onWidget}>
          {props.isActive ? Svgs.viewShow : Svgs.viewHide}
        </div>
      </div>
    </div>
    <div className="widget-content">{props.inline ? null : props.children}</div>
    <div className="widget-content-wrapper"></div>
  </div>
;
Widget.propTypes = {
  title: PropTypes.string,
  tooltip: PropTypes.string,
  handleActivate: PropTypes.func
};

export default Widget;
